import {API} from "./API";
import {User} from "../models/User";

export class UsersAPI extends API<User> {

	constructor () {
		super("users");
	}

	login (username: string, password: string) {
		let url = `/login`;
		// let payload = item;

		var data = {
			email: username,
			password: password
		}

		return API.axiosInstance.post(url, data);
	}

	currentUser () {
		let url = `/profile`;
		return API.axiosInstance.get(url);
	}

	forgotPasswordRequest (email: string) {

		let url = `/users/forgot-password`

		const data = {
			email: email,
		};

		return API.axiosInstance.post(url, data);
	}

	getByResetPasswordToken (token: string) {

		let url = `/users/reset-password-token/${token}`

		return API.axiosInstance.get(url)
	}

	resetPasswordRequest (id: string, password: string) {

		let url = `/users/reset-password`

		const data = {
			id: id,
			password: password
		};

		return API.axiosInstance.post(url, data);
	}
}
